
import { Component, Vue } from 'vue-property-decorator';

@Component<PageNotFound>({})
export default class PageNotFound extends Vue {
	private backToMenus(): void {
		this.$router.replace('/menus');
	}
}
